module.exports = __webpack_public_path__ + "static/media/next-icon-cold-water-o.83abd397.svg";